<template>
  <b-container
    v-if="renderPage"
    fluid
  >
    <div class="row" />
    <b-card title="Editar Cliente">
      <validation-observer
        ref="simpleRules"
        #default="{invalid}"
      >
        <b-form @submit.prevent>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Nome Completo"
                label-for="v-first-name"
              >
                <validation-provider
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-input
                    id="v-first-name"
                    v-model="req.name"
                    placeholder="Digite o nome do cliente"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Documento"
                label-for="v-document"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Documento"
                  rules="required|document"
                >
                  <b-form-input
                    id="v-document"
                    v-model="req.tax_id"
                    v-mask="['###.###.###-##', '##.###.###/####-##']"
                    type="text"
                    placeholder="Informe o CPF ou CNPJ"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Email"
                label-for="v-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-input
                    id="v-email"
                    v-model="req.email"
                    type="email"
                    placeholder="Email"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Telefone"
                label-for="v-mobile"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Phone"
                  rules="required|phone"
                >
                  <b-form-input
                    id="v-mobile"
                    v-model="req.phone"
                    v-mask="['(##) #####-####', '(##) ####-####']"
                    placeholder="Informe o telefone"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col
              md="12"
              class="d-flex justify-content-center mt-2"
            >
              <b-button
                :to="{ path: '/clientes' }"
                class="btn-back"
              >
                Voltar
              </b-button>
              <b-button
                type="submit"
                class="btn-save-client"
                variant="info"
                :disabled="invalid"
                @click.prevent="validationForm"
              >
                Editar
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </b-container>
</template>
<script>
import Ripple from 'vue-ripple-directive'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BContainer,
} from 'bootstrap-vue'
import {
  ValidationProvider,
  ValidationObserver,
} from 'vee-validate'

import {
  required,
  email,
} from '@validations'

import { callLoading } from '@/service/utilities/utilities'

import { getClient, updateClient } from '@/service/client/client'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BCard,
    BContainer,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      id: 30,
      isLoading: false,
      req: {
        name: null,
        email: null,
        tax_id: null,
        phone: null,
      },
      msg: [{
        name: 'O nome deve ser preenchido',
      }],
      renderPage: false,
      required,
      email,
    }
  },
  beforeRouteLeave(to, from, next) {
    this.renderPage = false
    next()
  },
  async mounted() {
    const { id } = this.$route.params
    this.id = id
    this.getClient()
  },
  methods: {
    success() {
      this.$swal({
        title: 'Cliente editado com sucesso',
        icon: 'success',
        timer: 1750,
        showConfirmButton: false,
        buttonsStyling: false,
      })
    },
    error() {
      this.$swal({
        text: 'Não foi possível editar o cliente',
        icon: 'error',
        timer: 1750,
        showConfirmButton: false,
        buttonsStyling: false,
      })
    },
    async validationForm() {
      await this.modal()
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          if (this.checker) {
            this.updateClient()
          }
        }
      })
    },
    async modal() {
      await this.$bvModal.msgBoxConfirm('Você tem certeza que deseja editar esse cliente?', {
        title: 'Por Favor Confirme',
        size: 'sm',
        okVariant: 'primary',
        okTitle: 'Sim',
        cancelTitle: 'Não',
        cancelVariant: 'outline-secondary',
        hideHeaderClose: false,
        centered: true,
      }).then(value => {
        this.checker = value
      })
    },
    async getClient() {
      callLoading(true)
      try {
        const { data, status } = await getClient(this.id)
        if (status !== 200) {
          this.$router.push('/error-404')
          return
        }
        this.req = data
      } catch {
        this.$router.push('/error-404')
      } finally {
        callLoading(false)
        this.renderPage = true
      }
    },
    async updateClient() {
      callLoading(true, true)
      try {
        const response = await updateClient(this.id, this.req)
        const { status } = response

        if (status === 200) {
          this.success()
          this.$router.push('/clientes')
        } else if (status === 422) {
          const { errors } = response.data
          errors.forEach(error => {
            const { field } = error
            if (field === 'email') { this.showEmailError = true } else if (field === 'tax_id') { this.showTaxIdError = true }
          })
        } else {
          this.error()
        }
      } catch {
        this.error()
      } finally {
        callLoading(false)
      }
    },
  },
}
</script>
<style scoped lang="scss">
  @import "@core/scss/vue/pages/client-style.scss";
</style>
